import { Site } from '@ps/web-core-enums';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import useIsMounted from '@swf/core/hooks/useIsMounted';
import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';

import type { Limits } from '../../../../types/responsibleGamingLimits';
import { getDepositLimitAmountRestrictions } from '../../../../utils/responsibleGamingLimits';
import Container from '../../../Container/Container';
import ResponsibleGamingLimits from '../../../ResponsibleGamingLimits/ResponsibleGamingLimits';

import {
  TXTCLI_Deposit_Limits,
  TXTWCL_Deposit_Limit_5,
  TXTWCL_Deposit_Limit_is_a_cap_on_how__ELL,
  TXTWCL_Responsible_Gaming_Limits
} from './RMFDepositLimit.messages.json';

const RMFDepositLimit: React.FC = () => {
  const request = useRequest();
  const [limits, setLimits] = useState<Limits>({} as Limits);
  const siteId = useSelector(select.cms.getSiteId);
  const isMounted = useIsMounted();

  const fetchUserLimits = useCallback(() => {
    request({
      service: 'responsiblegaming.userlimit'
    }).subscribe(({ body }) => {
      isMounted() && setLimits(getDepositLimitAmountRestrictions(body));
    });
  }, [isMounted, request]);

  useEffect(() => {
    isMounted() && fetchUserLimits();
  }, [fetchUserLimits, isMounted]);

  return (
    <Container
      page={RMFDepositLimit}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />
      }}
      pageTopTitle={
        <Translation {...(siteId === Site.FR ? TXTWCL_Deposit_Limit_5 : TXTCLI_Deposit_Limits)} />
      }
      pageTopSubtitle={<Translation {...TXTWCL_Deposit_Limit_is_a_cap_on_how__ELL} />}
    >
      <ResponsibleGamingLimits limits={limits} fieldName="rmf.deposit" />
    </Container>
  );
};

RMFDepositLimit.displayName = 'RMFDepositLimit';

export default RMFDepositLimit;
